import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
} from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { createCategory, fetchAllCategory } from "helpers/category_helper";
import Select from "react-select"
import { createSubCategory } from "helpers/subCategory_helper";

const CreateSubCategory = (props) => {
    document.title = "Content Management | Create Sub Category";




    const breadcrumbItems = [
        { title: "Sub Category", link: "#" },
        { title: "Create Sub Category", link: "#" },
    ]
    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])
    useEffect(() => {
        props.setBreadcrumbItems('Create Sub Category', breadcrumbItems)
    })
    const [category, setCategory] = useState(null);
    const [subCategoryName, setSubCategoryName] = useState("");
    const [subCategoryDescription, setSubCategoryDescription] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);
    const [categories, setCategories] = useState([]);

    const fetchCategories = async () => {
        try {
            const data = await fetchAllCategory();

            if (data?.success) {
                setCategories(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {
            if (!subCategoryDescription || !subCategoryName || !category) {
                setSpanDisplay("inline");
            }
            else {
                setLoader(true);
                const data = await createSubCategory({ name: subCategoryName, description: subCategoryDescription, categoryDto: category });
                setLoader(false);
                if (data?.success) {
                    toast.success(data?.message);
                    setSubCategoryDescription("");
                    setSubCategoryName("");
                    setCategory(null);
                }
                else {
                    toast.error(data?.message);
                }
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }

    };

    const handleSelectCategory = selectedOption => {
        setCategory(selectedOption);
    };
    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row >
                <Col>
                    <Card>
                        <CardBody className="col-lg-10 col-sm-12 col-xs-12">
                            <CardTitle className="h4">Create Class</CardTitle>
                            <form onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Category
                                    </label>
                                    <div className="col-md-10">
                                        <Select

                                            value={category}
                                            onChange={handleSelectCategory}
                                            options={categories}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                            classNamePrefix="select2-selection"
                                        />
                                        {!category && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>

                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Sub Category Name
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter new Sub Category"
                                            value={subCategoryName}
                                            maxLength="50"
                                            onChange={(e) => setSubCategoryName(e.target.value)} />

                                        {!subCategoryName && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Sub Category Description
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter New Description"
                                            maxLength="50"
                                            value={subCategoryDescription}
                                            onChange={(e) => setSubCategoryDescription(e.target.value)} />
                                        {!subCategoryDescription && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>


                                <Row className="mb-3">
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary w-md me-2">Create</button>
                                    </div>
                                </Row>
                            </form>

                        </CardBody>
                    </Card>
                </Col>
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateSubCategory);